import { call } from 'redux-saga/effects';
import { get } from 'lodash/fp';
import * as Api from '../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../helpers/saga';
import {
  requestOtp as requestOtpRoutine,
  verifyOtp as verifyOtpRoutine,
  forgotPassword as forgotPasswordRoutine
} from './routines';

const redirectToApp = () => {
  window.location.assign('/');
};

// Skip global toastr so Login can show inline messages.
const silentFailure = () => {};

export const requestOtp = ({ payload }) =>
  sagaRoutineRequest(requestOtpRoutine, {
    request: () => call(Api.requestOtp, payload),
    success(response) {
      if (!get('mfaRequired', response)) {
        redirectToApp();
      }
    },
    failure: silentFailure
  });

export const verifyOtp = ({ payload }) =>
  sagaRoutineRequest(verifyOtpRoutine, {
    request: () => call(Api.verifyOtp, payload),
    success() {
      redirectToApp();
    },
    failure: silentFailure
  });

export const forgotPassword = ({ payload }) =>
  sagaRoutineRequest(forgotPasswordRoutine, {
    request: () => call(Api.forgotPassword, payload),
    failure: silentFailure
  });
